/**
 * PilotContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled pilot container.
 */
const PilotContainer = styled.div<React.CSSProperties>`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 125; // Place pilot on top of the player and before the pause ad
`;

export default withOpacity(PilotContainer, true);
